import { defineComponent as _defineComponent } from 'vue'
import { useAutoRemovedResizeListener } from '@/composables/misc';
import TableActionsList from './TableActionsList.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TableColumnActionsWrapper',
  props: {
    displayMode: { default: 'on-hover' }
  },
  setup(__props: any) {



const showMobileVersion = ref(shouldShowMobileVersion());

function shouldShowMobileVersion(): boolean {
  return window.innerWidth <= 768;
}

function updateMobileVersionSetting() {
  showMobileVersion.value = shouldShowMobileVersion();
}

useAutoRemovedResizeListener(updateMobileVersionSetting);

return { __sfc: true,showMobileVersion, shouldShowMobileVersion, updateMobileVersionSetting, TableActionsList }
}

})